module.exports = __webpack_public_path__ + "img/login_banner.acd93611.png";